var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberSeven = function SvgIconNumberSeven(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 3.75a1 1 0 0 1 1-1h9a1 1 0 0 1 .949 1.316l-6 18a1 1 0 0 1-1.898-.632L15.113 4.75H7.5a1 1 0 0 1-1-1"
  })));
};
export default SvgIconNumberSeven;